import PropTypes from 'prop-types';
import Text from '@/components/component-library/Text';

const LoadingText = () => (
  <Text
    className='mob__genre-info-loading-text-line'
    loading
  />
);

const GenreInfoMobile = ({
  loading,
  description,
  showsCount,
  showsCountLoading
}) => {
  return (
    <div className='mob__genre-info'>
      { loading ? (
        <div className='mob__genre-info-loading-text'>
          <LoadingText />
          <LoadingText />
          <LoadingText />
        </div>
      ) : (
        <Text className='mob__genre-description'>
          { description }
        </Text>
      ) }
      <Text className='mob__genre-shows-count' loading={ showsCountLoading }>
        {`Shows count: ${showsCount || 0}`}
      </Text>
    </div>
  );
};

GenreInfoMobile.propTypes = {
  loading: PropTypes.bool,
  description: PropTypes.string,
  showsCount: PropTypes.number,
  showsCountLoading: PropTypes.bool
};

GenreInfoMobile.defaultProps = {
  loading: false,
  description: '',
  showsCount: undefined,
  showsCountLoading: false
};

export default GenreInfoMobile;
